import { createRoute } from '@tanstack/react-router'
import { rootRoute, requireAuth } from './__root'
import { ActivityLog } from '../pages/ActivityLog'

export const activityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/activity',
  beforeLoad: requireAuth,
  component: ActivityLog,
})
